module.exports = "https://cdn.littlereply.com/tt/resource/loading.0e6e0f46d7504242302bc8055ad9c8c2.gif";